window.fox = {};
window.fox.settings = {};

// IDと名称のマップ
window.fox.settings.model = {

//Apple iPhone
  AP2391: 'iPhone 17e',
  AP2279: 'iPhone 17',
  AP2280: 'iPhone 17 Pro',
  AP2281: 'iPhone Air',
  AP2282: 'iPhone 17 Pro Max',

  AP2267: 'iPhone 16e',
  AP2251: 'iPhone 16',
  AP2252: 'iPhone 16 Pro',
  AP2253: 'iPhone 16 Plus',
  AP2254: 'iPhone 16 Pro Max',
  AP2221: 'iPhone 15',
  AP2223: 'iPhone 15 Pro',
  AP2222: 'iPhone 15 Plus',
  AP2224: 'iPhone 15 Pro Max',
  AP2179: 'iPhone 14',
  AP2181: 'iPhone 14 Pro',
  AP2180: 'iPhone 14 Plus',
  AP2182: 'iPhone 14 Pro Max',
  AP2111: 'iPhone 13',
  AP2112: 'iPhone 13 Pro',
  AP2110: 'iPhone 13 mini',
  AP2113: 'iPhone 13 Pro Max',
  AP2107: 'iPhone 12',
  AP2108: 'iPhone 12 Pro',
  AP2106: 'iPhone 12 mini',
  AP2109: 'iPhone 12 Pro Max',
  AP2145: 'iPhone SE（第3世代）',
  AP2114: 'iPhone SE（第2世代）',
  AP2105: 'iPhone 11',
  AP2144: 'iPhone 11 Pro',
  AP2200: 'iPhone 11 Pro Max',
  AP2104: 'iPhone XR',
  AP2131: 'iPhone XS',
  AP2199: 'iPhone XS Max',
  AP2130: 'iPhone X',
  AP2127: 'iPhone 8',
  AP2198: 'iPhone 8 Plus',
  AP2126: 'iPhone 7',
  AP2197: 'iPhone 7 Plus',
  AP2196: 'iPhone 6s Plus',



//Galaxy
  SS2385: 'Galaxy S26',
  SS2386: 'Galaxy S26 Plus',
  SS2387: 'Galaxy S26 Ultra',
  SS2268: 'Galaxy S25',
  SS2269: 'Galaxy S25 Ultra',
  SS2238: 'Galaxy S24',
  SS2239: 'Galaxy S24 Ultra',
  SS2237: 'Galaxy S23 FE',
  SS2211: 'Galaxy S23',
  SS2212: 'Galaxy S23 Ultra',
  SS2147: 'Galaxy S22',
  SS2161: 'Galaxy S22 Ultra',
  SS2103: 'Galaxy S21 5G',
  SS2162: 'Galaxy S21+ 5G',
  SS2207: 'Galaxy S21 Ultra 5G',
  SS2135: 'Galaxy S20',
  SS2205: 'Galaxy S20+',
  SS2206: 'Galaxy S20 Ultra',
  SS2146: 'Galaxy S10',
  SS2204: 'Galaxy S10+',
  SS2209: 'Galaxy S9',
  SS2202: 'Galaxy S9+',
  
  SS2403: 'Galaxy Z Flip8',
  SS2286: 'Galaxy Z Flip7',
  SS2257: 'Galaxy Z Flip6',
  SS2226: 'Galaxy Z Flip5',
  
  SS2404: 'Galaxy Z Fold8',
  SS2287: 'Galaxy Z Fold7',
  SS2258: 'Galaxy Z Fold6',
  SS2227: 'Galaxy Z Fold5',

  SS2405: 'Galaxy Z Fold8 Ultra',
  
  SS2248: 'Galaxy A55 5G',
  SS2216: 'Galaxy A54 5G',
  SS2175: 'Galaxy A53 5G',
  SS2203: 'Galaxy A52 5G',
  SS2164: 'Galaxy A32 5G',
  SS2271: 'Galaxy A25 5G',
  SS2192: 'Galaxy A23 5G',
  
  SS2193: 'Galaxy Buds Pro',



  //Google Pixel
  GG2394: 'Pixel 11',
  GG2395: 'Pixel 11 Pro',
  GG2396: 'Pixel 11 Pro XL',
  GG2397: 'Pixel 11 Pro Fold',
  GG2317: 'Pixel 10a',
  GG2288: 'Pixel 10',
  GG2289: 'Pixel 10 Pro',
  GG2290: 'Pixel 10 Pro XL',
  GG2270: 'Pixel 9a',
  GG2255: 'Pixel 9',
  GG2256: 'Pixel 9 Pro',
  GG2259: 'Pixel 9 Pro XL',
  GG2235: 'Pixel 8a',
  GG2218: 'Pixel 8',
  GG2219: 'Pixel 8 Pro',
  GG2213: 'Pixel 7a',
  GG2183: 'Pixel 7',
  GG2184: 'Pixel 7 Pro',
  GG2178: 'Pixel 6a',
  GG2132: 'Pixel 6',
  GG2133: 'Pixel 6 Pro',
  GG2120: 'Pixel 5',
  GG2138: 'Pixel 5a 5G',

  GG2217: 'Pixel Fold',


//SONY Xperia
  SN2399: 'Xperia 1 VIII',
  SN2283: 'Xperia 1 VII',
  SN2246: 'Xperia 1 VI',
  SN2214: 'Xperia 1 V',
  SN2165: 'Xperia 1 IV',
  SN2172: 'Xperia 1 III',
  SN2141: 'Xperia 1 II',

  SN2225: 'Xperia 5 V',
  SN2194: 'Xperia 5 IV',
  SN2151: 'Xperia 5 III',
  SN2123: 'Xperia 5 II',
  SN2142: 'Xperia 5',

  SN2311: 'Xperia 10 VII',
  SN2247: 'Xperia 10 VI',
  SN2215: 'Xperia 10 V',
  SN2166: 'Xperia 10 IV',
  SN2125: 'Xperia 10 III',
  SN2143: 'Xperia 10 II',

  SN2167: 'Xperia Ace III',



//SHARP AQUOS
  SH2310: 'AQUOS sense10',
  SH2296: 'AQUOS sense9',
  SH2295: 'AQUOS sense8',
  SH2185: 'AQUOS sense7',
  SH2165: 'AQUOS sense6s',
  SH2148: 'AQUOS sense6',
  SH2170: 'AQUOS sense5G',
  SH2171: 'AQUOS sense3 basic',

  SH2284: 'AQUOS wish5',
  SH2294: 'AQUOS wish4',
  SH2293: 'AQUOS wish3',
  SH2177: 'AQUOS wish2',
  SH2149: 'AQUOS wish',

  SH2402: 'AQUOS R11',
  SH2285: 'AQUOS R10',
  SH2291: 'AQUOS R9',
  SH2292: 'AQUOS R9 Pro',

  SH2168: 'AQUOS zero6',


  //Xiaomi
  XM2313: 'Xiaomi 15T',
  XM2312: 'Xiaomi 15T Pro',
  XM2275: 'Xiaomi 14T',
  XM2276: 'Xiaomi 14T Pro',
  XM2232: 'Xiaomi 13T',
  XM2233: 'Xiaomi 13T Pro',
  XM2210: 'Xiaomi 12T Pro',
  XM2136: 'Xiaomi 11T',
  XM2137: 'Xiaomi 11T Pro',
  XM2266: 'Xiaomi Redmi 12C',
  
  XM2140: 'Xiaomi Mi 11 Lite 5G',
  XM2249: 'Redmi Note 13 Pro 5G',
  XM2250: 'Redmi Note 13 Pro+ 5G',
  XM2189: 'Redmi Note 11',
  XM2190: 'Redmi Note 11 Pro',
  XM2122: 'Redmi Note 10 Pro',
  XM2169: 'Redmi Note10 JE',
  XM2231: 'Redmi 12 5G',
  XM2121: 'Redmi 9T',



//OPPO
  OP2188: 'OPPO Reno7 A',
  OP2262: 'OPPO Reno9 A',
  OP2153: 'OPPO A55s 5G',
  OP2134: 'OPPO A54 5G',
  OP2315: 'OPPO Find X9',
  OP2163: 'OPPO Find X3 Pro',


//Motorola
  MT2306: 'Motorola edge 60 pro',
  MT2265: 'Motorola edge 50 pro',
  MT2264: 'Motorola edge 40 neo',
  MT2263: 'Motorola edge 40',
  MT2186: 'Motorola edge 30 PRO',
  MT2139: 'Motorola edge 20',

  MT2305: 'Motorola razr 60',

  MT2116: 'Motorola moto g100',
  MT2129: 'Motorola moto g50 5G',

  MT2187: 'Motorola moto g31',
  MT2201: 'Motorola moto g30',







//HUAWEI
  HW2117: 'HUAWEI P30 lite',



//arrows
  FC2150: 'arrows We',



//ZTE
  ZT2234: 'Libero Flip',

//PCケース
  NC2261: 'LAVIE SOL',

//アクセサリー
  n000: 'アクセサリー',
  // イヤホンケース(Apple)
  AP2370: 'AirPods（第4世代）',
  AP2156: 'AirPods（第3世代）',
  AP2372: 'AirPods Pro 3',
  AP2155: 'AirPods（第2世代）',
  AP2272: 'AirPods Pro 2',
  AP2154: 'AirPods（第1世代）',
  AP2157: 'AirPods Pro 1',

  AP2158: 'Apple Watch（38mm～41mm）',
  AP2159: 'Apple Watch（42mm～45mm）',

  // イヤホンケース(Samsung)
  SS2376: 'Galaxy Buds4',
  SS2381: 'Galaxy Buds4 Pro',
  SS2375: 'Galaxy Buds3',
  SS2380: 'Galaxy Buds3 Pro',
  SS2383: 'Galaxy Buds3 FE',
  SS2374: 'Galaxy Buds2',
  SS2379: 'Galaxy Buds2 Pro',
  SS2378: 'Galaxy Buds Pro',
  SS2382: 'Galaxy Buds FE',
  SS2377: 'Galaxy Buds Live',

//スマホショルダータグ
  NKSTGY: 'スマホショルダー(細)(ロープ/長さ調整可能) [ グレー ]',
  NKSTBKGD: 'スマホショルダー(細)(ロープ/長さ調整可能) [ ブラック+ゴールド ]',
  NKSTNVGD: 'スマホショルダー(細)(ロープ/長さ調整可能) [ ネイビー+ゴールド ]',
  BNKSTBK: 'スマホショルダー(太)(ロープ) [ ブラック ]',
  BNKSTBE: 'スマホショルダー(太)(ロープ) [ ベージュ ]',
  BNKSTDPGY: 'スマホショルダー(太)(ロープ) [ ディープグレー ]',
  HDSTGY: 'スマホハンドストラップ(細)(ロープ/長さ調整可能) [ グレー ]',
  HDSTBKGD: 'スマホハンドストラップ(細)(ロープ/長さ調整可能) [ ブラック＋ゴールド ]',
  HDSTNVGD: 'スマホハンドストラップ(細)(ロープ/長さ調整可能) [ ネイビー＋ゴールド ]',

// スマートウォッチバンド
// Apple
AP2331: 'Apple Watch Series 11 (42mm)',
AP2332: 'Apple Watch Series 11 (46mm)',
AP2329: 'Apple Watch Series 10 (42mm)',
AP2330: 'Apple Watch Series 10 (46mm)',
AP2323: 'Apple Watch Series 9 (41mm)',
AP2324: 'Apple Watch Series 9 (45mm)',
AP2318: 'Apple Watch Series 8 (41mm)',
AP2319: 'Apple Watch Series 8 (45mm)',
AP2316: 'Apple Watch Series 7 (41mm)',
AP2317: 'Apple Watch Series 7 (45mm)',
AP2312: 'Apple Watch Series 6 (40mm)',
AP2313: 'Apple Watch Series 6 (44mm)',
AP2310: 'Apple Watch Series 5 (40mm)',
AP2311: 'Apple Watch Series 5 (44mm)',
AP2308: 'Apple Watch Series 4 (40mm)',
AP2309: 'Apple Watch Series 4 (44mm)',
AP2306: 'Apple Watch Series 3 (38mm)',
AP2307: 'Apple Watch Series 3 (42mm)',
AP2304: 'Apple Watch Series 2 (38mm)',
AP2305: 'Apple Watch Series 2 (42mm)',
AP2302: 'Apple Watch Series 1 (38mm)',
AP2303: 'Apple Watch Series 1 (42mm)',
AP2300: 'Apple Watch Series 0 (38mm)',
AP2301: 'Apple Watch Series 0 (42mm)',
AP2327: 'Apple Watch Series SE（第3世代） (40mm)',
AP2328: 'Apple Watch Series SE（第3世代） (44mm)',
AP2320: 'Apple Watch Series SE（第2世代） (40mm)',
AP2321: 'Apple Watch Series SE（第2世代） (44mm)',
AP2314: 'Apple Watch Series SE（第1世代） (40mm)',
AP2315: 'Apple Watch Series SE（第1世代） (44mm)',
AP2326: 'Apple Watch Ultra 3 (49mm)',
AP2325: 'Apple Watch Ultra 2 (49mm)',
AP2322: 'Apple Watch Ultra (49mm)',

// Samsung
SS2388: 'Samsung Galaxy Watch 8 (40mm)',
SS2389: 'Samsung Galaxy Watch 8 (44mm)',
SS2390: 'Samsung Galaxy Watch 8 Classic',
SS2309: 'Samsung Galaxy Watch 7 (40mm)',
SS2310: 'Samsung Galaxy Watch 7 (44mm)',
SS2305: 'Samsung Galaxy Watch 6 (40mm)',
SS2306: 'Samsung Galaxy Watch 6 (44mm)',
SS2307: 'Samsung Galaxy Watch 6 Classic (43mm)',
SS2308: 'Samsung Galaxy Watch 6 Classic (47mm)',
SS2303: 'Samsung Galaxy Watch 5 (40mm)',
SS2304: 'Samsung Galaxy Watch 5 (44mm)',
SS2302: 'Samsung Galaxy Watch 5 Pro (45mm)',
SS2311: 'Samsung Galaxy Watch FE (40mm)',
SS2312: 'Samsung Galaxy Watch Ultra (47mm)',

// Garmin
GM2311: 'Garmin Fenix 8シリーズ（43mm）',
GM2312: 'Garmin Fenix 8シリーズ（47mm）',
GM2313: 'Garmin Fenix 8シリーズ（51mm）',
GM2308: 'Garmin Fenix 7シリーズ（42mm）',
GM2309: 'Garmin Fenix 7シリーズ（47mm）',
GM2310: 'Garmin Fenix 7シリーズ（51mm）',
GM2314: 'Garmin vivoactive 6（42.2mm）',
GM2315: 'Garmin Forerunner 570（42mm）',
GM2316: 'Garmin Forerunner 570（47mm）',
GM2307: 'Garmin Forerunner 165（43mm）',
GM2305: 'Garmin Forerunner 265 (46.1mm)',
GM2306: 'Garmin Forerunner 965 (47.2mm)',

// フォリオケース
NC2384: 'LAVIE Tab EX',

// スタンドカバー
AS2400: 'ASUS Chromebook CM32',
};

// 機種判定マスター
window.fox.settings.android_uas = {
    'OPPO A73': 'OP2101',
    'Galaxy A51 5G': 'SS2102',
    'Galaxy S21 5G': 'SS2103',
    'moto e7': 'MT2115',
    'moto g100': 'MT2116',
    'HUAWEI P30 lite': 'HW2117',
    'Google Pixel 4a': 'GG2118',
    'Google Pixel 4a 5G': 'GG2119',
    'Google Pixel 5': 'GG2120',
    'Redmi 9T': 'XM2121',
    'Redmi Note 10 Pro': 'XM2122',
    'SONY Xperia 5 II': 'SN2123',
    'SONY Xperia 1 III': 'SN2124',
    'SONY Xperia 10 III': 'SN2125',
};

//あなたのスマホを選択（画面右下）
window.fox.settings.model_groups = [
  {
    label: 'Apple',
    code: 'AP',
    slug: 'series-iPhone',
    code_sort: [
      'AP2391', /*iPhone 17e*/
      'AP2279', /*iPhone 17*/
      'AP2280', /*iPhone 17 Pro*/
      'AP2281', /*iPhone Air*/
      'AP2282', /*iPhone 17 Pro Max*/

      'AP2267', /*iPhone 16e*/
      'AP2251', /*iPhone 16*/
      'AP2252', /*iPhone 16 Pro*/
      'AP2253', /*iPhone 16 Plus*/
      'AP2254', /*iPhone 16 Pro Max*/
      'AP2221', /*iPhone 15*/
      'AP2223', /*iPhone 15 Pro*/
      'AP2222', /*iPhone 15 Plus*/
      'AP2224', /*iPhone 15 Pro Max*/
      'AP2179', /*iPhone 14*/
      'AP2181', /*iPhone 14 Pro*/
      'AP2180', /*iPhone 14 Plus*/
      'AP2182', /*iPhone 14 Pro Max*/
      'AP2111', /*iPhone 13*/
      'AP2112', /*iPhone 13 Pro*/
      'AP2110', /*iPhone 13 mini*/
      'AP2113', /*iPhone 13 Pro Max*/
      'AP2107', /*iPhone 12*/
      'AP2108', /*iPhone 12 Pro*/
      'AP2106', /*iPhone 12 mini*/
      'AP2109', /*iPhone 12 Pro Max*/
      'AP2145', /*iPhone SE（第3世代）*/
      'AP2114', /*iPhone SE（第2世代）*/
      'AP2105', /*iPhone 11*/
      'AP2144', /*iPhone 11 Pro*/
      'AP2200', /*iPhone 11 Pro Max*/
      'AP2104', /*iPhone XR*/
      'AP2131', /*iPhone XS*/
      'AP2199', /*iPhone XS Max*/
      'AP2130', /*iPhone X*/
      'AP2127', /*iPhone 8*/
      'AP2198', /*iPhone 8 Plus*/
      'AP2126', /*iPhone 7*/
      'AP2197', /*iPhone 7 Plus*/
      'AP2196', /*iPhone 6s Plus*/
    ]
  },
  {
    label: 'Samsung',
    code: 'SS',
    slug: 'series-galaxy',
    code_sort: [
      'SS2385', /*Galaxy S26*/
      'SS2386', /*Galaxy S26 Plus*/
      'SS2387', /*Galaxy S26 Ultra*/
      'SS2268', /*Galaxy S25*/
      'SS2269', /*Galaxy S25 Ultra*/
      'SS2238', /*Galaxy S24*/
      'SS2239', /*Galaxy S24 Ultra*/
      'SS2237', /*Galaxy S23 FE*/
      'SS2211', /*Galaxy S23*/
      'SS2212', /*Galaxy S23 Ultra*/
      'SS2147', /*Galaxy S22*/
      'SS2161', /*Galaxy S22 Ultra*/
      'SS2103', /*Galaxy S21 5G*/
      'SS2162', /*Galaxy S21+ 5G*/
      'SS2207', /*Galaxy S21 Ultra 5G*/
      'SS2135', /*Galaxy S20*/
      'SS2205', /*Galaxy S20+*/
      'SS2206', /*Galaxy S20 Ultra*/
      'SS2146', /*Galaxy S10*/
      'SS2204', /*Galaxy S10+*/
      'SS2209', /*Galaxy S9*/
      'SS2202', /*Galaxy S9+*/
      
      'SS2403', /*Galaxy Z Flip8*/
      'SS2286', /*Galaxy Z Flip7*/
      'SS2257', /*Galaxy Z Flip6*/
      'SS2226', /*Galaxy Z Flip5*/

      'SS2404', /*Galaxy Z Fold8*/
      'SS2287', /*Galaxy Z Fold7*/
      'SS2258', /*Galaxy Z Fold6*/
      'SS2227', /*Galaxy Z Fold5*/

      'SS2405', /*Galaxy Z Fold8 Ultra*/
      
      'SS2248', /*Galaxy A55 5G*/
      'SS2216', /*Galaxy A54 5G*/
      'SS2175', /*Galaxy A53 5G*/
      'SS2203', /*Galaxy A52 5G*/
      'SS2164', /*Galaxy A32 5G*/
      'SS2271', /*Galaxy A25 5G*/
      'SS2192', /*Galaxy A23 5G*/
      
      'SS2193', /*Galaxy Buds Pro*/
    ]
  },
  {
    label: 'Google',
    code: 'GG',
    slug: 'series-google-Pixel',
    code_sort: [
      'GG2394', /*Pixel 11*/
      'GG2395', /*Pixel 11 Pro*/
      'GG2396', /*Pixel 11 Pro XL*/
      'GG2397', /*Pixel 11 Pro Fold*/
      'GG2317', /*Pixel 10a*/
      'GG2288', /*Pixel 10*/
      'GG2289', /*Pixel 10 Pro*/
      'GG2290', /*Pixel 10 Pro XL*/
      'GG2270', /*Pixel 9a*/
      'GG2255', /*Pixel 9*/
      'GG2256', /*Pixel 9 Pro*/
      'GG2259', /*Pixel 9 Pro XL*/
      'GG2235', /*Pixel 8a*/
      'GG2218', /*Pixel 8*/
      'GG2219', /*Pixel 8 Pro*/
      'GG2213', /*Pixel 7a*/
      'GG2183', /*Pixel 7*/
      'GG2184', /*Pixel 7 Pro*/
      'GG2178', /*Pixel 6a*/
      'GG2132', /*Pixel 6*/
      'GG2133', /*Pixel 6 Pro*/
      'GG2120', /*Pixel 5*/
      'GG2138', /*Pixel 5a 5G*/

      'GG2217', /*Pixel Fold*/
    ]
  },
  {
    label: 'Sony',
    code: 'SN',
    slug: 'series-Xperia',
    code_sort: [
      'SN2399', /*Xperia 1 VIII*/
      'SN2283', /*Xperia 1 VII*/
      'SN2246', /*Xperia 1 VI*/
      'SN2214', /*Xperia 1 V*/
      'SN2165', /*Xperia 1 IV*/
      'SN2172', /*Xperia 1 III*/
      'SN2141', /*Xperia 1 II*/

      'SN2225', /*Xperia 5 V*/
      'SN2194', /*Xperia 5 IV*/
      'SN2151', /*Xperia 5 III*/
      'SN2123', /*Xperia 5 II*/
      'SN2142', /*Xperia 5*/

      'SN2311', /*Xperia 10 VII*/
      'SN2247', /*Xperia 10 VI*/
      'SN2215', /*Xperia 10 V*/
      'SN2166', /*Xperia 10 IV*/
      'SN2125', /*Xperia 10 III*/
      'SN2143', /*Xperia 10 II*/

      'SN2167', /*Xperia Ace III*/
    ]
  },
  {
    label: 'SHARP',
    code: 'SH',
    slug: 'series-AQUOS',
    code_sort: [
      'SH2402', /*AQUOS R11*/
      'SH2285', /*AQUOS R10*/
      'SH2291', /*AQUOS R9*/
      'SH2292', /*AQUOS R9 Pro*/

      'SH2284', /*AQUOS wish5*/
      'SH2294', /*AQUOS wish4*/
      'SH2293', /*AQUOS wish3*/
      'SH2177', /*AQUOS wish2*/
      'SH2149', /*AQUOS wish*/

      'SH2310', /*AQUOS sense10*/
      'SH2296', /*AQUOS sense9*/
      'SH2295', /*AQUOS sense8*/
      'SH2185', /*AQUOS sense7*/
      'SH2165', /*AQUOS sense6s*/
      'SH2148', /*AQUOS sense6*/
      'SH2170', /*AQUOS sense5G*/
      'SH2171', /*AQUOS sense3 basic*/

      'SH2168', /*AQUOS zero6*/
    ]
  },
  {
    label: 'Xiaomi',
    code: 'XM',
    slug: '',
    code_sort: [
      'XM2313', /*Xiaomi 15T*/
      'XM2312', /*Xiaomi 15T Pro*/
      'XM2275', /*Xiaomi 14T*/
      'XM2276', /*Xiaomi 14T Pro*/
      'XM2232', /*Xiaomi 13T*/
      'XM2233', /*Xiaomi 13T Pro*/
      'XM2210', /*Xiaomi 12T Pro*/
      'XM2136', /*Xiaomi 11T*/
      'XM2137', /*Xiaomi 11T Pro*/
      'XM2266', /*Xiaomi Redmi 12C*/
      'XM2140', /*Xiaomi Mi 11 Lite 5G*/
      
      'XM2249', /*Redmi Note 13 Pro 5G*/
      'XM2250', /*Redmi Note 13 Pro+ 5G*/
      'XM2189', /*Redmi Note 11*/
      'XM2190', /*Redmi Note 11 Pro*/
      'XM2122', /*Redmi Note 10 Pro*/
      'XM2169', /*Redmi Note10 JE*/
      'XM2231', /*Redmi 12 5G*/
      'XM2121', /*Redmi 9T*/
    ]
  },
  {
    label: 'OPPO',
    code: 'OP',
    slug: '',
    code_sort: [
      'OP2262', /*'OPPO Reno9 A*/
      'OP2188', /*'OPPO Reno7 A*/
      'OP2153', /*'OPPO A55s 5G*/
      'OP2134', /*'OPPO A54 5G*/
      'OP2315', /*'OPPO Find X9*/
      'OP2163', /*'OPPO Find X3 Pro*/
    ]
  },
  {
    label: 'Motorola',
    code: 'MT',
    slug: '',
    code_sort: [
      'MT2306', /*Motorola edge 60 pro*/
      'MT2265', /*Motorola edge 50 pro*/
      'MT2264', /*Motorola edge 40 neo*/
      'MT2263', /*Motorola edge 40*/
      'MT2186', /*Motorola edge 30 PRO*/
      'MT2139', /*Motorola edge 20*/

      'MT2305', /*Motorola razr 60*/

      'MT2116', /*Motorola moto g100*/
      'MT2129', /*Motorola moto g50 5G*/

      'MT2187', /*Motorola moto g31*/
      'MT2201', /*Motorola moto g30*/
    ]
  },
  {
    label: 'FCNT',
    code: 'FC',
    slug: 'series-arrows',
    code_sort: [
      'FC2150', /*arrows We*/
    ]
  },
  {
    label: 'ZTE',
    code: 'ZT',
    slug: 'series-zte',
    code_sort: [
      'ZT2234', /*Libero Flip*/
    ]
  },
  {
    label: 'HUAWEI',
    code: 'HW',
    slug: 'series-hw',
    code_sort: [
        'HW2117', /*HUAWEI P30 lite*/
    ]
  }
];

//チェックボックス表示（カラム左　対応機種）
window.fox.settings.model_groups_checkbox = [
  {
    label: 'iPhone',
    code: 'AP',
    slug: 'series-iPhone',
    code_sort: [
      'AP2391', /*iPhone 17e*/
      'AP2279', /*iPhone 17*/
      'AP2280', /*iPhone 17 Pro*/
      'AP2281', /*iPhone Air*/
      'AP2282', /*iPhone 17 Pro Max*/

      'AP2267', /*iPhone 16e*/
      'AP2251', /*iPhone 16*/
      'AP2252', /*iPhone 16 Pro*/
      'AP2253', /*iPhone 16 Plus*/
      'AP2254', /*iPhone 16 Pro Max*/
      'AP2221', /*iPhone 15*/
      'AP2223', /*iPhone 15 Pro*/
      'AP2222', /*iPhone 15 Plus*/
      'AP2224', /*iPhone 15 Pro Max*/
      'AP2179', /*iPhone 14*/
      'AP2181', /*iPhone 14 Pro*/
      'AP2180', /*iPhone 14 Plus*/
      'AP2182', /*iPhone 14 Pro Max*/
      'AP2111', /*iPhone 13*/
      'AP2112', /*iPhone 13 Pro*/
      'AP2110', /*iPhone 13 mini*/
      'AP2113', /*iPhone 13 Pro Max*/
      'AP2107', /*iPhone 12*/
      'AP2108', /*iPhone 12 Pro*/
      'AP2106', /*iPhone 12 mini*/
      'AP2109', /*iPhone 12 Pro Max*/
      'AP2145', /*iPhone SE（第3世代）*/
      'AP2114', /*iPhone SE（第2世代）*/
      'AP2105', /*iPhone 11*/
      'AP2144', /*iPhone 11 Pro*/
      'AP2200', /*iPhone 11 Pro Max*/
      'AP2104', /*iPhone XR*/
      'AP2131', /*iPhone XS*/
      'AP2199', /*iPhone XS Max*/
      'AP2130', /*iPhone X*/
      'AP2127', /*iPhone 8*/
      'AP2198', /*iPhone 8 Plus*/
      'AP2126', /*iPhone 7*/
      'AP2197', /*iPhone 7 Plus*/
      'AP2196', /*iPhone 6s Plus*/
    ]
  },
  {
    label: 'Android',
    code: '',
    slug: 'series-android',
    code_sort: [
    //Galaxyシリーズ
      'SS2385', /*Galaxy S26*/
      'SS2386', /*Galaxy S26 Plus*/
      'SS2387', /*Galaxy S26 Ultra*/
      'SS2268', /*Galaxy S25*/
      'SS2269', /*Galaxy S25 Ultra*/
      'SS2238', /*Galaxy S24*/
      'SS2239', /*Galaxy S24 Ultra*/
      'SS2237', /*Galaxy S23 FE*/
      'SS2211', /*Galaxy S23*/
      'SS2212', /*Galaxy S23 Ultra*/
      'SS2147', /*Galaxy S22*/
      'SS2161', /*Galaxy S22 Ultra*/
      'SS2103', /*Galaxy S21 5G*/
      'SS2162', /*Galaxy S21+ 5G*/
      'SS2207', /*Galaxy S21 Ultra 5G*/
      'SS2135', /*Galaxy S20*/
      'SS2205', /*Galaxy S20+*/
      'SS2206', /*Galaxy S20 Ultra*/
      'SS2146', /*Galaxy S10*/
      'SS2204', /*Galaxy S10+*/
      'SS2209', /*Galaxy S9*/
      'SS2202', /*Galaxy S9+*/
      
      'SS2403', /*Galaxy Z Flip8*/
      'SS2286', /*Galaxy Z Flip7*/
      'SS2257', /*Galaxy Z Flip6*/
      'SS2226', /*Galaxy Z Flip5*/

      'SS2404', /*Galaxy Z Fold8*/
      'SS2287', /*Galaxy Z Fold7*/
      'SS2258', /*Galaxy Z Fold6*/
      'SS2227', /*Galaxy Z Fold5*/

      'SS2405', /*Galaxy Z Fold8 Ultra*/
      
      'SS2248', /*Galaxy A55 5G*/
      'SS2216', /*Galaxy A54 5G*/
      'SS2175', /*Galaxy A53 5G*/
      'SS2203', /*Galaxy A52 5G*/
      'SS2164', /*Galaxy A32 5G*/
      'SS2271', /*Galaxy A25 5G*/
      'SS2192', /*Galaxy A23 5G*/
      
      'SS2193', /*Galaxy Buds Pro*/


    //Googleシリーズ
      'GG2394', /*Pixel 11*/
      'GG2395', /*Pixel 11 Pro*/
      'GG2396', /*Pixel 11 Pro XL*/
      'GG2397', /*Pixel 11 Pro Fold*/
      'GG2317', /*Pixel 10a*/
      'GG2288', /*Pixel 10*/
      'GG2289', /*Pixel 10 Pro*/
      'GG2290', /*Pixel 10 Pro XL*/
      'GG2270', /*Pixel 9a*/
      'GG2255', /*Pixel 9*/
      'GG2256', /*Pixel 9 Pro*/
      'GG2259', /*Pixel 9 Pro XL*/
      'GG2235', /*Pixel 8a*/
      'GG2218', /*Pixel 8*/
      'GG2219', /*Pixel 8 Pro*/
      'GG2213', /*Pixel 7a*/
      'GG2183', /*Pixel 7*/
      'GG2184', /*Pixel 7 Pro*/
      'GG2178', /*Pixel 6a*/
      'GG2132', /*Pixel 6*/
      'GG2133', /*Pixel 6 Pro*/
      'GG2120', /*Pixel 5*/
      'GG2138', /*Pixel 5a 5G*/

      'GG2217', /*Pixel Fold*/


    //Xperiaシリーズ]
      'SN2399', /*Xperia 1 VIII*/
      'SN2283', /*Xperia 1 VII*/
      'SN2246', /*Xperia 1 VI*/
      'SN2214', /*Xperia 1 V*/
      'SN2165', /*Xperia 1 IV*/
      'SN2172', /*Xperia 1 III*/
      'SN2141', /*Xperia 1 II*/

      'SN2225', /*Xperia 5 V*/
      'SN2194', /*Xperia 5 IV*/
      'SN2151', /*Xperia 5 III*/
      'SN2123', /*Xperia 5 II*/
      'SN2142', /*Xperia 5*/

      'SN2311', /*Xperia 10 VII*/
      'SN2247', /*Xperia 10 VI*/
      'SN2215', /*Xperia 10 V*/
      'SN2166', /*Xperia 10 IV*/
      'SN2125', /*Xperia 10 III*/
      'SN2143', /*Xperia 10 II*/

      'SN2167', /*Xperia Ace III*/



    //AQUOSシリーズ
      'SH2402', /*AQUOS R11*/
      'SH2285', /*AQUOS R10*/
      'SH2291', /*AQUOS R9*/
      'SH2292', /*AQUOS R9 Pro*/

      'SH2284', /*AQUOS wish5*/
      'SH2294', /*AQUOS wish4*/
      'SH2293', /*AQUOS wish3*/
      'SH2177', /*AQUOS wish2*/
      'SH2149', /*AQUOS wish*/

      'SH2310', /*AQUOS sense10*/
      'SH2296', /*AQUOS sense9*/
      'SH2295', /*AQUOS sense8*/
      'SH2185', /*AQUOS sense7*/
      'SH2165', /*AQUOS sense6s*/
      'SH2148', /*AQUOS sense6*/
      'SH2170', /*AQUOS sense5G*/
      'SH2171', /*AQUOS sense3 basic*/

      'SH2168', /*AQUOS zero6*/


    //Xiaomiシリーズ
      'XM2313', /*Xiaomi 15T*/
      'XM2312', /*Xiaomi 15T Pro*/
      'XM2275', /*Xiaomi 14T*/
      'XM2276', /*Xiaomi 14T Pro*/
      'XM2232', /*Xiaomi 13T*/
      'XM2233', /*Xiaomi 13T Pro*/
      'XM2210', /*Xiaomi 12T Pro*/
      'XM2136', /*Xiaomi 11T*/
      'XM2137', /*Xiaomi 11T Pro*/
      'XM2266', /*Xiaomi Redmi 12C*/
      'XM2140', /*Xiaomi Mi 11 Lite 5G*/
      
      'XM2249', /*Redmi Note 13 Pro 5G*/
      'XM2250', /*Redmi Note 13 Pro+ 5G*/
      'XM2189', /*Redmi Note 11*/
      'XM2190', /*Redmi Note 11 Pro*/
      'XM2122', /*Redmi Note 10 Pro*/
      'XM2169', /*Redmi Note10 JE*/
      'XM2231', /*Redmi 12 5G*/
      'XM2121', /*Redmi 9T*/


    //OPPOシリーズ
      'OP2262', /*'OPPO Reno9 A*/
      'OP2188', /*'OPPO Reno7 A*/
      'OP2153', /*'OPPO A55s 5G*/
      'OP2134', /*'OPPO A54 5G*/
      'OP2315', /*'OPPO Find X9*/
      'OP2163', /*'OPPO Find X3 Pro*/


    //Motorolaシリーズ
      'MT2306', /*Motorola edge 60 pro*/
      'MT2265', /*Motorola edge 50 pro*/
      'MT2264', /*Motorola edge 40 neo*/
      'MT2263', /*Motorola edge 40*/
      'MT2186', /*Motorola edge 30 PRO*/
      'MT2139', /*Motorola edge 20*/

      'MT2305', /*Motorola razr 60*/

      'MT2116', /*Motorola moto g100*/
      'MT2129', /*Motorola moto g50 5G*/

      'MT2187', /*Motorola moto g31*/
      'MT2201', /*Motorola moto g30*/


    //arrowsシリーズ
      'FC2150', /*arrows We*/ 


    //HUAWEIシリーズ
        'HW2117', /*HUAWEI P30 lite*/

    //ZTEシリーズ
      'ZT2234', /*Libero Flip*/
    ]
  }
];

// グロナビに表示する機種
window.fox.settings.models_displaying_global_nav = [
  //iPhone
    'AP2391', /*iPhone 17e*/
    'AP2279', /*iPhone 17*/
    'AP2280', /*iPhone 17 Pro*/
    'AP2281', /*iPhone Air*/
    'AP2282', /*iPhone 17 Pro Max*/

    'AP2267', /*iPhone 16e*/
    'AP2251', /*iPhone 16*/
    'AP2252', /*iPhone 16 Pro*/
    'AP2253', /*iPhone 16 Plus*/
    'AP2254', /*iPhone 16 Pro Max*/
    'AP2221', /*iPhone 15*/
    'AP2223', /*iPhone 15 Pro*/
    'AP2222', /*iPhone 15 Plus*/
    'AP2224', /*iPhone 15 Pro Max*/
    'AP2179', /*iPhone 14*/
    'AP2181', /*iPhone 14 Pro*/
    'AP2180', /*iPhone 14 Plus*/
    'AP2182', /*iPhone 14 Pro Max*/
    'AP2111', /*iPhone 13*/
    'AP2112', /*iPhone 13 Pro*/
    'AP2110', /*iPhone 13 mini*/
    'AP2113', /*iPhone 13 Pro Max*/
    'AP2107', /*iPhone 12*/
    'AP2108', /*iPhone 12 Pro*/
    'AP2106', /*iPhone 12 mini*/
    'AP2109', /*iPhone 12 Pro Max*/
    'AP2145', /*iPhone SE（第3世代）*/
    'AP2114', /*iPhone SE（第2世代）*/
    'AP2105', /*iPhone 11*/
    'AP2144', /*iPhone 11 Pro*/
    'AP2200', /*iPhone 11 Pro Max*/
    'AP2104', /*iPhone XR*/
    'AP2131', /*iPhone XS*/
    'AP2199', /*iPhone XS Max*/
    'AP2130', /*iPhone X*/
    'AP2127', /*iPhone 8*/
    'AP2198', /*iPhone 8 Plus*/
    'AP2126', /*iPhone 7*/
    'AP2197', /*iPhone 7 Plus*/
    'AP2196', /*iPhone 6s Plus*/

  // Android
    'SS2385', /*Galaxy S26*/
    'SS2387', /*Galaxy S26 Ultra*/
    'GG2288', /*Pixel 10*/
];

// IDと名称のマップ(大分類・ケース)
window.fox.settings.h1case = {
  h1_HY: 'Hybrid Case',
  h1_SP: 'スリムプロテクションケース',
  h1_PC: 'LAVIE SOL着せ替えケース',
  h1_FL: 'Folio Case',
  h1_HYSL: 'Hybrid Case with Sling',
  h1_FLSL: 'Folio Case with Sling',
  h1_SP: 'スリムプロテクションケース',
  h1_SPLR: 'リボン付きケース',
  h1_NKST: 'スリムプロテクションケース+スマホショルダー(細)(ロープ/長さ調整可能)',
  h1_HDST: 'スリムプロテクションケース+スマホハンドストラップ(細)(ロープ/長さ調整可能)',
  h1_BNKST: 'スリムプロテクションケース+スマホショルダー(太)(ロープ)',
  h1_AWCB: 'Apple Watchクリアバンド',
  h1_SPLRBK: 'スリムプロテクションケース LANVIN en Bleu RIBBON Black',
  h1_SPLRSP: 'スリムプロテクションケース LANVIN en Bleu RIBBON Sakura Pink',
  h1_SPLRNV: 'スリムプロテクションケース LANVIN en Bleu RIBBON Navy',
  h1_SPLRCL: 'スリムプロテクションケース LANVIN en Bleu RIBBON Clear',
  h1_SPLRCY: 'スリムプロテクションケース LANVIN en Bleu RIBBON Cream Yellow',
  h1_SPLRSL: 'スリムプロテクションケース LANVIN en Bleu RIBBON Silver',
  h1_SPLRGD: 'スリムプロテクションケース LANVIN en Bleu RIBBON Gold',
  h1_SPLRPK: 'スリムプロテクションケース LANVIN en Bleu RIBBON Sakura Pink',
  h1_RS: 'リング付き着せ替えシート',
  h1_RSBK: 'リング付きシート ブラック',
  h1_RSGD: 'リング付きシート ゴールド',
  h1_RSPU: 'リング付きシート パープル',
  h1_GB2: 'Galaxy Buds2',
  h1_GBP: 'Galaxy Buds Pro',
  h1_GB2P: 'Galaxy Buds2 Pro',
  h1_GWSB: 'Galaxy Watch4 シリコンバンド',
  h1_GF: 'ギフトラッピング袋',
  h1_GYPL: '着せ替えクリアプレート',
  h1_GYPELR: '着せ替えクリアプレート LANVIN en Bleu RIBBON',
  h1_CC: 'クリアケース',
  h1_SPSRBK: 'スリムプロテクションケース - STAND & RING RIBBON Black',
  h1_SPSRPK: 'スリムプロテクションケース - STAND & RING RIBBON Sakura Pink',
  h1_SPSRSL: 'スリムプロテクションケース - STAND & RING RIBBON Silver',
  h1_APS: 'アートパネルスピーカー',
  h1_APSPL: 'アートパネル',
  h1_CW: 'MagSafe対応カードウォレット',
  h1_NKSTGYT: 'スマホショルダータグ(細)(ロープ/長さ調整可能) [ グレー ]',
  h1_NKSTBKGDT: 'スマホショルダータグ(細)(ロープ/長さ調整可能) [ ブラック+ゴールド ]',
  h1_NKSTNVGDT: 'スマホショルダータグ(細)(ロープ/長さ調整可能) [ ネイビー+ゴールド ]',
  h1_BNKSTBKT: 'スマホショルダータグ(太)(ロープ) [ ブラック ]',
  h1_BNKSTBET: 'スマホショルダータグ(太)(ロープ) [ ベージュ ]',
  h1_BNKSTDPGYT: 'スマホショルダータグ(太)(ロープ) [ ディープグレー ]',
  h1_HDSTGYT: 'スマホハンドストラップタグ(細)(ロープ/長さ調整可能) [ グレー ]',
  h1_HDSTBKGDT: 'スマホハンドストラップタグ(細)(ロープ/長さ調整可能) [ ブラック＋ゴールド ]',
  h1_HDSTNVGDT: 'スマホハンドストラップタグ(細)(ロープ/長さ調整可能) [ ネイビー＋ゴールド ]',
  h1_AWLB: 'Apple Watchレザーバンド',
  h1_SSTG: 'スマホショルダータグ',
  h1_SGSBK: 'スマートグリップスタンド [ Black ]',
  h1_SGSWH: 'スマートグリップスタンド [ White ]',
  h1_FR: 'スリムプロテクションプレミアムケース',
  h1_PC: 'LAVIE SOL着せ替えケース',
  h1_FM: 'スリムプロテクションプレミアムケース with MagSafe ホワイトリング',
  h1_FB: 'スリムプロテクションプレミアムケース LANVIN en Bleu - STAND & RING RIBBON',
  h1_FM_black_ring: 'スリムプロテクションプレミアムケース with MagSafe ブラックリング',
  h1_PW: 'プレミアムカードウォレット',
  h1_PS: 'プレミアムリングスタンド',
  h1_PN: 'プレミアムパネル',
  h1_FP: 'プレミアムスクエアケース with Pixelsnap',
  h1_FS: 'プレミアムスクエアケース with MagSafe',
  h1_MS: 'プレミアムスクエアケース with SnapMag',
  h1_SC: 'スマートウォッチクリアバンド',
  h1_SL: 'スマートウォッチレザーバンド',
  h1_FN: 'プレミアムスクエアケース',
  h1_PP: 'プレミアムパネル with Pixelsnap',
  h1_PM: 'プレミアムパネル with MagSafe',
  h1_TB: 'フォリオケース',
  h1_AK: 'アクリルキーホルダー',
  h1_NM: 'ネームキーホルダー',
  h1_TA: 'Tシャツ型アクリルキーホルダー',
  h1_BC: 'スタンドカバー'
};

window.fox.settings.h1case_casetype = [
  'h1_HYSL',
  'h1_FLSL',
  'h1_SPLR',
  'h1_NKST',
  'h1_HDST',
  'h1_BNKST',
  'h1_GB2',
  'h1_GBP',
  'h1_GB2P',
];

// IDと名称のマップ(大分類・アクセサリー)
window.fox.settings.h1accessory = {
  h1_SB: 'Sticking Battery',
  h1_PG: '液晶保護ガラス',
  h1_MB: 'MagSafe Mobile Battery',
  h1_AWCB: 'Apple Watchクリアバンド',
  h1_AP: 'AirPodsケース',
  h1_SR: 'スマホリング',
  h1_NK: 'スマホショルダー(細)(ロープ/長さ調整可能)',
  h1_HD: 'スマホハンドストラップ(細)(ロープ/長さ調整可能)',
  h1_BNK: 'スマホショルダー(太)(ロープ)',
  h1_SHSTAP: 'スマホショルダー(細) with AirPodsホルダー(ロープ)',
  h1_ST: 'Strap',
  h1_ST: 'Strap',
  h1_NKST: 'スリムプロテクションケース+スマホショルダー(細)(ロープ/長さ調整可能)',
  h1_HDST: 'スリムプロテクションケース+スマホハンドストラップ(細)(ロープ/長さ調整可能)',
  h1_BNKST: 'スリムプロテクションケース+スマホショルダー(太)(ロープ)',
  h1_SPLRBK: 'スリムプロテクションケース LANVIN en Bleu RIBBON Black',
  h1_SPLRPK: 'スリムプロテクションケース LANVIN en Bleu RIBBON Sakura Pink',
  h1_SPLRNV: 'スリムプロテクションケース LANVIN en Bleu RIBBON Navy',
  h1_SPLRCL: 'スリムプロテクションケース LANVIN en Bleu RIBBON Clear',
  h1_SPLRCY: 'スリムプロテクションケース LANVIN en Bleu RIBBON Cream Yellow',
  h1_SPLRSL: 'スリムプロテクションケース LANVIN en Bleu RIBBON Silver',
  h1_SPLRGD: 'スリムプロテクションケース LANVIN en Bleu RIBBON Gold',
  h1_GB2: 'Galaxy Buds2',
  h1_GBP: 'Galaxy Buds Pro',
  h1_GB2P: 'Galaxy Buds2 Pro',
  h1_RS: 'Galaxy Z Flip4 リング付き着せ替えシート',
  h1_GWSB: 'Galaxy Watch4 シリコンバンド',
  h1_GYPL: '着せ替えクリアプレート',
  h1_GYPELR: '着せ替えクリアプレート LANVIN en Bleu RIBBON',
  h1_CC: 'クリアケース',
  h1_SPSRBK: 'スリムプロテクションケース - STAND & RING RIBBON Black',
  h1_SPSRPK: 'スリムプロテクションケース - STAND & RING RIBBON Sakura Pink',
  h1_SPSRSL: 'スリムプロテクションケース - STAND & RING RIBBON Silver',
  h1_APS: 'アートパネルスピーカー',
  h1_APSPL: 'アートパネル',
  h1_CW: 'MagSafe対応カードウォレット',
  h1_NKSTGYT: 'スマホショルダータグ(細)(ロープ/長さ調整可能) [ グレー ]',
  h1_NKSTBKGDT: 'スマホショルダータグ(細)(ロープ/長さ調整可能) [ ブラック+ゴールド ]',
  h1_NKSTNVGDT: 'スマホショルダータグ(細)(ロープ/長さ調整可能) [ ネイビー+ゴールド ]',
  h1_BNKSTBKT: 'スマホショルダータグ(太)(ロープ) [ ブラック ]',
  h1_BNKSTBET: 'スマホショルダータグ(太)(ロープ) [ ベージュ ]',
  h1_BNKSTDPGYT: 'スマホショルダータグ(太)(ロープ) [ ディープグレー ]',
  h1_HDSTGYT: 'スマホハンドストラップタグ(細)(ロープ/長さ調整可能) [ グレー ]',
  h1_HDSTBKGDT: 'スマホハンドストラップタグ(細)(ロープ/長さ調整可能) [ ブラック＋ゴールド ]',
  h1_HDSTNVGDT: 'スマホハンドストラップタグ(細)(ロープ/長さ調整可能) [ ネイビー＋ゴールド ]',
  h1_AWLB: 'Apple Watchレザーバンド',
  h1_SSTG: 'スマホショルダータグ',
  h1_SGSBK: 'スマートグリップスタンド [ Black ]',
  h1_SGSWH: 'スマートグリップスタンド [ White ]',
  h1_LGR2: 'ラインストーンレンズガラス(２レンズ) ',
  h1_LGR3: 'ラインストーンレンズガラス(３レンズ) ',
  h1_LG2: 'レンズガラス(２レンズ) ',
  h1_LG3: 'レンズガラス(３レンズ) ',
  h1_PW: 'プレミアムカードウォレット',
  h1_PN: 'プレミアムパネル',
};

window.fox.settings.h1_en =
  (window.caseplayItemTypeTranslations && window.caseplayItemTypeTranslations.en) || {};
window.fox.settings.h1 = {
  ...window.fox.settings.h1case ,
  ...window.fox.settings.h1accessory,
  ...(document.documentElement.lang === 'en' ? window.fox.settings.h1_en : {}),
};



// タグとケースタイプの説明を管理するオブジェクト
const caseTypeDescriptions = {
  // h1_HY: 'Hybrid Caseの説明テキスト',
  h1_SP: '<b>1.2m</b><br>の耐衝撃性能<br><br>質感のある<br><b>表刷り</b><br><br>Magsafe<br><b>非対応</b><br><br>フレームと<br>パネルの<br><b>一体型構造</b>',
  // h1_PC: 'LAVIE SOL着せ替えケースの説明テキスト',
  // h1_FL: 'Folio Caseの説明テキスト',
  // h1_HYSL: 'Hybrid Case with Slingの説明テキスト',
  // h1_FLSL: 'Folio Case with Slingの説明テキスト',
  // h1_SPLR: 'リボン付きケースの説明テキスト',
  // h1_NKST: 'スリムプロテクションケース+スマホショルダー(細)(ロープ/長さ調整可能)の説明テキスト',
  // h1_HDST: 'スリムプロテクションケース+スマホハンドストラップ(細)(ロープ/長さ調整可能)の説明テキスト',
  // h1_BNKST: 'スリムプロテクションケース+スマホショルダー(太)(ロープ)の説明テキスト',
  // h1_AWCB: 'Apple Watchクリアバンドの説明テキスト',
  // h1_SPLRBK: 'スリムプロテクションケース LANVIN en Bleu RIBBON Blackの説明テキスト',
  // h1_SPLRSP: 'スリムプロテクションケース LANVIN en Bleu RIBBON Sakura Pinkの説明テキスト',
  // h1_SPLRNV: 'スリムプロテクションケース LANVIN en Bleu RIBBON Navyの説明テキスト',
  // h1_SPLRCL: 'スリムプロテクションケース LANVIN en Bleu RIBBON Clearの説明テキスト',
  // h1_SPLRCY: 'スリムプロテクションケース LANVIN en Bleu RIBBON Cream Yellowの説明テキスト',
  // h1_SPLRSL: 'スリムプロテクションケース LANVIN en Bleu RIBBON Silverの説明テキスト',
  // h1_SPLRGD: 'スリムプロテクションケース LANVIN en Bleu RIBBON Goldの説明テキスト',
  // h1_RS: 'リング付き着せ替えシートの説明テキスト',
  // h1_RSBK: 'リング付きシート ブラックの説明テキスト',
  // h1_RSGD: 'リング付きシート ゴールドの説明テキスト',
  // h1_RSPU: 'リング付きシート パープルの説明テキスト',
  // h1_GB2: 'Galaxy Buds2の説明テキスト',
  // h1_GBP: 'Galaxy Buds Proの説明テキスト',
  // h1_GB2P: 'Galaxy Buds2 Proの説明テキスト',
  // h1_GWSB: 'Galaxy Watch4 シリコンバンドの説明テキスト',
  // h1_GF: 'ギフトラッピング袋の説明テキスト',
  // h1_GYPL: '着せ替えクリアプレートの説明テキスト',
  // h1_GYPELR: '着せ替えクリアプレート LANVIN en Bleu RIBBONの説明テキスト',
  // h1_CC: 'クリアケースの説明テキスト',
  // h1_SPSRBK: 'スリムプロテクションケース - STAND & RING RIBBON Blackの説明テキスト',
  // h1_SPSRPK: 'スリムプロテクションケース - STAND & RING RIBBON Sakura Pinkの説明テキスト',
  // h1_SPSRSL: 'スリムプロテクションケース - STAND & RING RIBBON Silverの説明テキスト',
  // h1_APS: 'アートパネルスピーカーの説明テキスト',
  // h1_APSPL: 'アートパネルの説明テキスト',
  // h1_CW: 'MagSafe対応カードウォレットの説明テキスト',
  // h1_NKSTGYT: 'スマホショルダータグ(細)(ロープ/長さ調整可能) [ グレー ]の説明テキスト',
  // h1_NKSTBKGDT: 'スマホショルダータグ(細)(ロープ/長さ調整可能) [ ブラック+ゴールド ]の説明テキスト',
  // h1_NKSTNVGDT: 'スマホショルダータグ(細)(ロープ/長さ調整可能) [ ネイビー+ゴールド ]の説明テキスト',
  // h1_BNKSTBKT: 'スマホショルダータグ(太)(ロープ) [ ブラック ]の説明テキスト',
  // h1_BNKSTBET: 'スマホショルダータグ(太)(ロープ) [ ベージュ ]の説明テキスト',
  // h1_BNKSTDPGYT: 'スマホショルダータグ(太)(ロープ) [ ディープグレー ]の説明テキスト',
  // h1_HDSTGYT: 'スマホハンドストラップタグ(細)(ロープ/長さ調整可能) [ グレー ]の説明テキスト',
  // h1_HDSTBKGDT: 'スマホハンドストラップタグ(細)(ロープ/長さ調整可能) [ ブラック＋ゴールド ]の説明テキスト',
  // h1_HDSTNVGDT: 'スマホハンドストラップタグ(細)(ロープ/長さ調整可能) [ ネイビー＋ゴールド ]の説明テキスト',
  // h1_AWLB: 'Apple Watchレザーバンドの説明テキスト',
  // h1_SSTG: 'スマホショルダータグの説明テキスト',
  // h1_SGSBK: 'スマートグリップスタンド [ Black ]の説明テキスト',
  // h1_SGSWH: 'スマートグリップスタンド [ White ]の説明テキスト',
  h1_FR: '<b>3.6m</b><br>の耐衝撃性能<br><br>発色が美しい<br><b>裏刷り</b><br><br>Magsafe<br><b>非対応</b><br><br>フレームと<br>パネルの<br><b>分離式構造</b><br><br><a href="https://caseplay.shop/pages/slimprotectionpremiumcase_2" class="product-inv-care-link">商品詳細は<br>こちら</a>',
  // h1_PC: 'LAVIE SOL着せ替えケースの説明テキスト',
  h1_FM: '<b>3.6m</b><br>の耐衝撃性能<br><br>発色が美しい<br><b>裏刷り</b><br><br>Magsafe<br><b>対応</b><br><br>フレームと<br>パネルの<br><b>分離式構造</b>',
  h1_FM_black_ring: '<b>3.6m</b><br>の耐衝撃性能<br><br>発色が美しい<br><b>裏刷り</b><br><br>Magsafe<br><b>対応</b><br><br>フレームと<br>パネルの<br><b>分離式構造</b>',
  h1_PN: '発色が美しい<br><b>裏刷り</b><br><br>フレームと<br>パネルの<br><b>分離式構造</b>',
  h1_FP: '<b>3.6m</b><br>の耐衝撃性能<br><br>発色が美しい<br><b>裏刷り</b><br><br>Pixelsnap<br><b>対応</b><br><br>フレームと<br>パネルの<br><b>分離式構造</b>',
  h1_FS: '<b>3.6m</b><br>の耐衝撃性能<br><br>発色が美しい<br><b>裏刷り</b><br><br>MagSafe<br><b>対応</b><br><br>フレームと<br>パネルの<br><b>分離式構造</b>',
};





// IDと名称のマップ(ケース素材)（検索UIでは使用していない）
window.fox.settings.material = {
  m_RP: '再生プラスチック',
  m_GL: 'Glass',
  m_SP: '確認中',
  m_NKSTGY: 'ポリエステル',
  m_NKSTBKGD: 'ポリエステル',
  m_NKSTNVGD: 'ポリエステル',
  m_HDSTGY: 'ポリエステル',
  m_HDSTBKGD: 'ポリエステル',
  m_HDSTNVGD: 'ポリエステル',
  m_BNKSTORPUBL: 'ポリエステル',
  m_BNKSTORPUDP: 'ポリエステル',
  m_BNKSTORPI: 'ポリエステル',
  m_SHSTAPBK: 'ポリエステル',
  m_SHSTAPPK: 'ポリエステル',
  m_PC: 'プラスチック',
  m_TPU: 'TPU',
  m_APTPU: 'TPU',
  m_AWCBTPU: 'TPU',
  m_LRBK: 'ヴィーガンレザー',
  m_LRCL: 'ヴィーガンレザー',
  m_LRCY: 'ヴィーガンレザー',
  m_LRGD: 'ヴィーガンレザー',
  m_LRNV: 'ヴィーガンレザー',
  m_LRPK: 'ヴィーガンレザー',
  m_LRSL: 'ヴィーガンレザー',
  m_RSCLBK: 'リング付き着せ替えシート クリアブラック',
  m_RSCL: 'リング付き着せ替えシート クリア',
  m_RSBK: 'リング付きシート ブラック',
  m_RSGD: 'リング付きシート ゴールド',
  m_RSPU: 'リング付きシート パープル',
  m_GBP: 'TPU',
  m_GB2P: 'TPU',
  m_GWCBWH: 'シリコン',
  m_GWCBPP: 'シリコン',
  m_GWCBPG: 'シリコン',
  m_CC: 'ポリカーボネート',
  m_SRRBK: 'ヴィーガンレザー',
  m_SRRPK: 'ヴィーガンレザー',
  m_SRRSL: 'ヴィーガンレザー',
  m_APSABS: 'ABS',
  m_APSPLABS: 'ABS',
  m_CWVL: 'ヴィーガンレザー',
  m_NKSTGYT: 'スマホショルダータグ',
  m_NKSTBKGDT: 'スマホショルダータグ',
  m_NKSTNVGDT: 'スマホショルダータグ',
  m_BNKSTBKT: 'スマホショルダータグ',
  m_BNKSTBET: 'スマホショルダータグ',
  m_BNKSTDPGYT: 'スマホショルダータグ',
  m_HDSTGYT: 'スマホショルダータグ',
  m_HDSTBKGDT: 'スマホショルダータグ',
  m_HDSTNVGDT: 'スマホショルダータグ',
  m_AWLBVL: 'ヴィーガンレザー',
  m_SSTGTPU: 'TPU',
  m_SGSBKPC: 'プラスチック',
  m_SGSWHPC: 'プラスチック',
  m_FT: 'クリアフレーム',
  m_FB: 'クリアブラックフレーム',
  m_CL: 'クリアベース',
  m_CB: 'クリアブラックフレーム',
  m_WT: 'クリア',
  m_WB: 'クリアブラック',
  m_PL: 'クリア',
  m_PS: 'ホワイトリング',
  m_PK: 'ブラックリング',
  m_MS: 'ホワイトリング',
  m_MK: 'ブラックリング',
  m_DG: 'ダークグレイ',
  m_OW: 'オフホワイト',
};

// カラー名称とカラーコードのマップ（現状存在だけで使用していない）
window.fox.settings.color = {
  'cl_レッド': '#E50303',
  'cl_イエロー': '#ffc200',
  'cl_オレンジ': '#ff8e00',
  'cl_グリーン': '#42c000',
  'cl_グレー': '#9d9a9b',
  'cl_ネイビー': '#1f0d61',
  'cl_パープル': '#8e00ff',
  'cl_ピンク': '#ff69db',
  'cl_ブラウン': '#ba8245',
  'cl_ブラック': '#000',
  'cl_ブルー': '#0000ff',
  'cl_ベージュ': '#D1B48A',
  'cl_ホワイト': '#fff',
  'cl_マルチカラー': '#fff',
  'cl_ライトブルー': '#7eb5d1',
};

// デフォルト機種（Apple iPhone X）
window.fox.settings.default_model = 'AP2130';
const ACCESSORY_QUERY_MODEL = "model";
const ACCESSORY_QUERY_DESIGN = "design";

window.fox.settings.buyTogetherAccessoryList = [
  {
    tag: 'h1_PG',
    query: ACCESSORY_QUERY_MODEL,
  },
  {
    tag: 'h1_SB',
    query: ACCESSORY_QUERY_DESIGN,
  },
  {
    tag: 'h1_MB',
    query: ACCESSORY_QUERY_DESIGN,
  },
  {
    tag: 'h1_AP',
    query: ACCESSORY_QUERY_DESIGN,
  },
  {
    tag: 'h1_SR',
    query: ACCESSORY_QUERY_DESIGN,
  },
  {
    tag: 'h1_ST',
    query: ACCESSORY_QUERY_DESIGN,
  },
  {
    tag: 'h1_NK',
    query: ACCESSORY_QUERY_DESIGN,
  }
];


// ここにモデルデータを追加
window.fox.settings.model_groupss = [
  {
    label: 'iPhoneシリーズ',
    code: 'AP',
    code_sort: [
      'AP2391', /*iPhone 17e*/
      'AP2279', /*iPhone 17*/
      'AP2280', /*iPhone 17 Pro*/
      'AP2281', /*iPhone Air*/
      'AP2282', /*iPhone 17 Pro Max*/

      'AP2267', /*iPhone 16e*/
      'AP2251', /*iPhone 16*/
      'AP2252', /*iPhone 16 Pro*/
      'AP2253', /*iPhone 16 Plus*/
      'AP2254', /*iPhone 16 Pro Max*/
      'AP2221', /*iPhone 15*/
      'AP2223', /*iPhone 15 Pro*/
      'AP2222', /*iPhone 15 Plus*/
      'AP2224', /*iPhone 15 Pro Max*/
      'AP2179', /*iPhone 14*/
      'AP2181', /*iPhone 14 Pro*/
      'AP2180', /*iPhone 14 Plus*/
      'AP2182', /*iPhone 14 Pro Max*/
      'AP2111', /*iPhone 13*/
      'AP2112', /*iPhone 13 Pro*/
      'AP2110', /*iPhone 13 mini*/
      'AP2113', /*iPhone 13 Pro Max*/
      'AP2107', /*iPhone 12*/
      'AP2108', /*iPhone 12 Pro*/
      'AP2106', /*iPhone 12 mini*/
      'AP2109', /*iPhone 12 Pro Max*/
      'AP2145', /*iPhone SE（第3世代）*/
      'AP2114', /*iPhone SE（第2世代）*/
      'AP2105', /*iPhone 11*/
      'AP2144', /*iPhone 11 Pro*/
      'AP2200', /*iPhone 11 Pro Max*/
      'AP2104', /*iPhone XR*/
      'AP2131', /*iPhone XS*/
      'AP2199', /*iPhone XS Max*/
      'AP2130', /*iPhone X*/
      'AP2127', /*iPhone 8*/
      'AP2198', /*iPhone 8 Plus*/
      'AP2126', /*iPhone 7*/
      'AP2197', /*iPhone 7 Plus*/
      'AP2196' /*iPhone 6s Plus*/
    ]
  },
  {
    label: 'Galaxyシリーズ',
    code: 'SS',
    code_sort: [
      'SS2385', /*Galaxy S26*/
      'SS2386', /*Galaxy S26 Plus*/
      'SS2387', /*Galaxy S26 Ultra*/
      'SS2268', /*Galaxy S25*/
      'SS2269', /*Galaxy S25 Ultra*/
      'SS2238', /*Galaxy S24*/
      'SS2239', /*Galaxy S24 Ultra*/
      'SS2237', /*Galaxy S23 FE*/
      'SS2211', /*Galaxy S23*/
      'SS2212', /*Galaxy S23 Ultra*/
      'SS2147', /*Galaxy S22*/
      'SS2161', /*Galaxy S22 Ultra*/
      'SS2103', /*Galaxy S21 5G*/
      'SS2162', /*Galaxy S21+ 5G*/
      'SS2207', /*Galaxy S21 Ultra 5G*/
      'SS2135', /*Galaxy S20*/
      'SS2205', /*Galaxy S20+*/
      'SS2206', /*Galaxy S20 Ultra*/
      'SS2146', /*Galaxy S10*/
      'SS2204', /*Galaxy S10+*/
      'SS2209', /*Galaxy S9*/
      'SS2202', /*Galaxy S9+*/
      
      'SS2403', /*Galaxy Z Flip8*/
      'SS2286', /*Galaxy Z Flip7*/
      'SS2257', /*Galaxy Z Flip6*/
      'SS2226', /*Galaxy Z Flip5*/

      'SS2404', /*Galaxy Z Fold8*/
      'SS2287', /*Galaxy Z Fold7*/
      'SS2258', /*Galaxy Z Fold6*/
      'SS2227', /*Galaxy Z Fold5*/

      'SS2405', /*Galaxy Z Fold8 Ultra*/
      
      'SS2248', /*Galaxy A55 5G*/
      'SS2216', /*Galaxy A54 5G*/
      'SS2175', /*Galaxy A53 5G*/
      'SS2203', /*Galaxy A52 5G*/
      'SS2164', /*Galaxy A32 5G*/
      'SS2271', /*Galaxy A25 5G*/
      'SS2192', /*Galaxy A23 5G*/
      
      'SS2193' /*Galaxy Buds Pro*/
    ]
  },
  {
    label: 'Googleシリーズ',
    code: 'GG',
    code_sort: [
      'GG2394', /*Pixel 11*/
      'GG2395', /*Pixel 11 Pro*/
      'GG2396', /*Pixel 11 Pro XL*/
      'GG2397', /*Pixel 11 Pro Fold*/
      'GG2317', /*Pixel 10a*/
      'GG2288', /*Pixel 10*/
      'GG2289', /*Pixel 10 Pro*/
      'GG2290', /*Pixel 10 Pro XL*/
      'GG2270', /*Pixel 9a*/
      'GG2255', /*Pixel 9*/
      'GG2256', /*Pixel 9 Pro*/
      'GG2259', /*Pixel 9 Pro XL*/
      'GG2235', /*Pixel 8a*/
      'GG2218', /*Pixel 8*/
      'GG2219', /*Pixel 8 Pro*/
      'GG2213', /*Pixel 7a*/
      'GG2183', /*Pixel 7*/
      'GG2184', /*Pixel 7 Pro*/
      'GG2178', /*Pixel 6a*/
      'GG2132', /*Pixel 6*/
      'GG2133', /*Pixel 6 Pro*/
      'GG2120', /*Pixel 5*/
      'GG2138', /*Pixel 5a 5G*/

      'GG2217' /*Pixel Fold*/
    ]
  },
  {
    label: 'Xperiaシリーズ',
    code: 'SN',
    code_sort: [
      'SN2399', /*Xperia 1 VIII*/
      'SN2283', /*Xperia 1 VII*/
      'SN2246', /*Xperia 1 VI*/
      'SN2214', /*Xperia 1 V*/
      'SN2165', /*Xperia 1 IV*/
      'SN2172', /*Xperia 1 III*/
      'SN2141', /*Xperia 1 II*/

      'SN2225', /*Xperia 5 V*/
      'SN2194', /*Xperia 5 IV*/
      'SN2151', /*Xperia 5 III*/
      'SN2123', /*Xperia 5 II*/
      'SN2142', /*Xperia 5*/

      'SN2311', /*Xperia 10 VII*/
      'SN2247', /*Xperia 10 VI*/
      'SN2215', /*Xperia 10 V*/
      'SN2166', /*Xperia 10 IV*/
      'SN2125', /*Xperia 10 III*/
      'SN2143', /*Xperia 10 II*/

      'SN2167' /*Xperia Ace III*/
    ]
  },
  {
    label: 'AQUOSシリーズ',
    code: 'SH',
    code_sort: [
      'SH2402', /*AQUOS R11*/
      'SH2285', /*AQUOS R10*/
      'SH2291', /*AQUOS R9*/
      'SH2292', /*AQUOS R9 Pro*/

      'SH2284', /*AQUOS wish5*/
      'SH2294', /*AQUOS wish4*/
      'SH2293', /*AQUOS wish3*/
      'SH2177', /*AQUOS wish2*/
      'SH2149', /*AQUOS wish*/

      'SH2310', /*AQUOS sense10*/
      'SH2296', /*AQUOS sense9*/
      'SH2295', /*AQUOS sense8*/
      'SH2185', /*AQUOS sense7*/
      'SH2165', /*AQUOS sense6s*/
      'SH2148', /*AQUOS sense6*/
      'SH2170', /*AQUOS sense5G*/
      'SH2171', /*AQUOS sense3 basic*/

      'SH2168' /*AQUOS zero6*/
    ]
  },
  {
    label: 'Xiaomiシリーズ',
    code: 'XM',
    code_sort: [
      'XM2313', /*Xiaomi 15T*/
      'XM2312', /*Xiaomi 15T Pro*/
      'XM2275', /*Xiaomi 14T*/
      'XM2276', /*Xiaomi 14T Pro*/
      'XM2232', /*Xiaomi 13T*/
      'XM2233', /*Xiaomi 13T Pro*/
      'XM2210', /*Xiaomi 12T Pro*/
      'XM2136', /*Xiaomi 11T*/
      'XM2137', /*Xiaomi 11T Pro*/
      'XM2266', /*Xiaomi Redmi 12C*/
      'XM2140', /*Xiaomi Mi 11 Lite 5G*/
      
      'XM2249', /*Redmi Note 13 Pro 5G*/
      'XM2250', /*Redmi Note 13 Pro+ 5G*/
      'XM2189', /*Redmi Note 11*/
      'XM2190', /*Redmi Note 11 Pro*/
      'XM2122', /*Redmi Note 10 Pro*/
      'XM2169', /*Redmi Note10 JE*/
      'XM2231', /*Redmi 12 5G*/
      'XM2121' /*Redmi 9T*/
    ]
  },
  {
    label: 'OPPOシリーズ',
    code: 'OP',
    code_sort: [
      'OP2262', /*'OPPO Reno9 A*/
      'OP2188', /*'OPPO Reno7 A*/
      'OP2153', /*'OPPO A55s 5G*/
      'OP2134', /*'OPPO A54 5G*/
      'OP2315', /*'OPPO Find X9*/
      'OP2163' /*'OPPO Find X3 Pro*/
    ]
  },
  {
    label: 'Motorolaシリーズ',
    code: 'MT',
    code_sort: [
      'MT2306', /*Motorola edge 60 pro*/
      'MT2265', /*Motorola edge 50 pro*/
      'MT2264', /*Motorola edge 40 neo*/
      'MT2263', /*Motorola edge 40*/
      'MT2186', /*Motorola edge 30 PRO*/
      'MT2139', /*Motorola edge 20*/

      'MT2305', /*Motorola razr 60*/

      'MT2116', /*Motorola moto g100*/
      'MT2129', /*Motorola moto g50 5G*/

      'MT2187', /*Motorola moto g31*/
      'MT2201' /*Motorola moto g30*/
    ]
  },
  {
    label: 'arrowsシリーズ',
    code: 'FC',
    code_sort: [
      'FC2150' /*arrows We*/
    ]
  },
  {
    label: 'ZTEシリーズ',
    code: 'ZT',
    code_sort: [
      'ZT2234' /*Libero Flip*/
    ]
  },
   {
    label: 'HUAWEIシリーズ',
    code: 'HW',
    code_sort: [
      'HW2117' /*HUAWEI P30 lite*/
    ]
  }
];